import {Component, OnInit, Inject, ViewEncapsulation} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {ModalData} from '../../../models/model-data';

@Component({
    selector: 'app-dialogdata',
    templateUrl: './dialogData.component.html',
    styleUrls: ['./dialogData.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class dialogDataComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<dialogDataComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ModalData) {

    }


    ngOnInit() {
    }

}
